var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"liff-loading"},[_c('img',{staticClass:"loading-img",attrs:{"src":require("@/assets/svgs/loading.svg")}})])
}]

export { render, staticRenderFns }